import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { OrderFormComponent } from './components/order-form/order-form.component'
import { OverviewComponent } from './components/overview/overview.component';
import { MembershipsComponent } from './components/memberships/memberships.component';
import { TrainingCalendarComponent } from './components/training-calendar/training-calendar.component';
import { TrainingHistoryComponent } from './components/training-history/training-history.component';
import { BillingHistoryComponent } from './components/billing-history/billing-history.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { ManageCreditCardsComponent } from './components/manage-credit-cards/manage-credit-cards.component';
import { ManageHistoryComponent } from './components/manage-history/manage-history.component';
import { TrainingListComponent } from './components/training-list/training-list.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { DownloadSoftwareComponent } from './components/download-software/download-software.component';
import { GISHistoryComponent } from './components/gis-history/gis-history.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { AuthGuardService } from 'app/services/auth.guard.service';

const AccountRouting: Routes = [


  {
    path: 'account/reset-password',
    redirectTo: '/authentication/signin?forgotPassword=true',
    pathMatch: 'full',
  },
  {
    path: 'account', component: DashboardView,
    canActivate: [AuthGuardService],
    children: [
      { path: 'overview', component: OverviewComponent },
      { path: 'manage-payment-info', component: ManageCreditCardsComponent },
      { path: 'manage-history', component: ManageHistoryComponent },
      { path: 'training-list', component: TrainingListComponent },
      { path: 'product-memberships', component: MembershipsComponent },
      { path: 'training-calendar', component: TrainingCalendarComponent },
      { path: 'training-calendar/:id', component: TrainingCalendarComponent },
      { path: 'training-history', component: TrainingHistoryComponent },
      { path: 'billing-history', component: BillingHistoryComponent },
      { path: 'credit-card', component: CreditCardComponent },
      { path: 'add-credit-card', component: CreditCardComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'my-profile', component: MyProfileComponent },
      { path: 'software-download', component: DownloadSoftwareComponent },
      { path: 'gis-purchase-history', component: GISHistoryComponent },
      // handle all other routes
      { path: '**', component: OverviewComponent } // AccountDashboardComponent
    ]
  },



];


@NgModule({
  imports: [RouterModule.forChild(AccountRouting)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
